<!-- Payment Methods Grid -->
<div
  class="payment-methods-grid ks-p-5"
  style="overflow-y: scroll; max-height: 75vh"
  *ngIf="paymentMethods.length > 0"
>
  <div
    class="header-title ks-m-0 ks-p-3 ks-justify-content-space-between"
    style="display: flex"
    *ngIf="creditCards.length > 0"
  >
    <div>Credit Cards</div>
    <div>
      <span
        class="ks-pr-2 icons-cards svg-icon-sm"
        inlineSVG="assets/media/svg/icons/Payment/mastercard.svg"
      ></span>
      <span
        class="ks-pr-2 icons-cards svg-icon-sm"
        inlineSVG="assets/media/svg/icons/Payment/visa.svg"
      ></span>
      <span
        class="ks-pr-2 icons-cards svg-icon-sm"
        inlineSVG="assets/media/svg/icons/Payment/discover.svg"
      ></span>
    </div>
  </div>

  <fieldset
    *ngIf="creditCards.length > 0"
    class="ks-checkboxes-wrapper ks-scrollbar-secondary ks-p-3 ks-pb-6 ks-mb-0"
    style="max-height: 215px"
  >
    <kt-checkbox
      *ngFor="let card of creditCards"
      [isRadio]="true"
      [label]="getMaskedNumber(card)"
      [iconLabel]="getIconSource(card)"
      [color]="card.is_default ? 'tertiary' : 'secondary'"
      [value]="card"
      [control]="getFormControl('cards')"
    ></kt-checkbox>
  </fieldset>

  <div
    class="header-title ks-m-0 ks-p-3 ks-justify-content-space-between"
    style="display: flex"
    *ngIf="bankAccounts.length > 0"
  >
    <div>ACH Bank transfer</div>
  </div>

  <fieldset
    *ngIf="bankAccounts.length > 0"
    class="ks-checkboxes-wrapper ks-scrollbar-secondary ks-p-3 ks-pb-6 ks-mb-10"
    style="max-height: 215px"
  >
    <kt-checkbox
      *ngFor="let card of bankAccounts"
      [isRadio]="true"
      [label]="getMaskedNumber(card)"
      [color]="card.is_default ? 'tertiary' : 'secondary'"
      [value]="card"
      [control]="getFormControl('cards')"
    ></kt-checkbox>
  </fieldset>
</div>

<!-- Empty State -->
<div class="empty-state" *ngIf="paymentMethods.length === 0">
  <span inlineSVG="assets/icons/two-credit-card.svg" class="svg-icon svg-icon-7x"></span>
  <h3 class="empty-title">No saved payment methods</h3>
</div>
